module.exports = __webpack_public_path__ + "static/media/WETH-logo.603872f9.png";